import { useMemo } from 'react';
import { BUSINESS_SETTER_MAPPINGS } from '../setterMappings';
import { Meta } from '../types';
const metaCache = new WeakMap();
/**
 * 深拷贝，支持函数、循环引用等
 */
function deepClone<T>(obj: T, hash = new WeakMap()): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // 处理循环引用
  if (hash.has(obj as object)) {
    return hash.get(obj as object);
  }

  // 处理日期对象
  if (obj instanceof Date) {
    return new Date(obj.getTime()) as any;
  }

  // 处理正则表达式
  if (obj instanceof RegExp) {
    return new RegExp(obj.source, obj.flags) as any;
  }

  // 处理数组和对象
  const cloneObj = Array.isArray(obj) ? [] : {};
  hash.set(obj as object, cloneObj);

  Object.entries(obj).forEach(([key, value]) => {
    if (typeof value === 'function') {
      // 直接复制函数引用
      cloneObj[key] = value;
    } else {
      cloneObj[key] = deepClone(value, hash);
    }
  });

  return cloneObj as T;
}
export function useSetterTransform(dsl: Meta) {
  return useMemo(() => {
     // 检查缓存
    if (metaCache.has(dsl)) {
      return metaCache.get(dsl);
    }
    if (!dsl.setters?.props) return dsl;

    
  
    console.log('=== Transform Begin ===');
    console.log('Before:', JSON.stringify(dsl,null,2));

    // 1. 深拷贝 DSL 
    // ⚠️不能用 JSON.stringify/parse 做深拷贝，因为会丢失函数
    const panelDSL = deepClone(dsl);
    
    // 2. 收集需要替换的业务 setter 及其配置
    const businessSetters = new Map<string, any>();
    panelDSL.setters.props.forEach(prop => {
      if (BUSINESS_SETTER_MAPPINGS[prop.setter]) {
        const mapping = BUSINESS_SETTER_MAPPINGS[prop.setter];
        businessSetters.set(prop.name, {
          mapping,
          originalProp: prop
        });
      }
    });

    // 3. 处理 layout
    let layoutString = JSON.stringify(panelDSL.setters.layout);
    businessSetters.forEach(({ mapping, originalProp }, propName) => {
      const searchValue = `"setters/props/${propName}"`;
      const replacement = JSON.stringify({
        name: propName,
        title: originalProp.title,
        fields: mapping.setters.props.map((p: any) => `setters/props/${p.name}`)
      });
      layoutString = layoutString.replace(searchValue, replacement);
    });
    panelDSL.setters.layout = JSON.parse(layoutString);

    // 4. 处理 props
    const newProps: any[] = [];
    panelDSL.setters.props.forEach(prop => {
      if (businessSetters.has(prop.name)) {
        const { mapping } = businessSetters.get(prop.name);
        newProps.push(...mapping.setters.props);
      } else {
        newProps.push(prop);
      }
    });
    panelDSL.setters.props = newProps;

    // 5. 合并 defaultValues、transforms、datasource
    businessSetters.forEach(({ mapping, originalProp }, propName) => {
      // 合并 defaultValues
      if (mapping.defaultValues) {
        // 删除原来的属性值
        delete panelDSL.defaultValues.props[propName];
        
        // 合并新的属性值
        panelDSL.defaultValues.props = {
          ...panelDSL.defaultValues.props,
          ...mapping.defaultValues.props
        };
      }
    
      // 合并 transforms
      if (mapping.transforms) {
        panelDSL.transforms = {
          ...panelDSL.transforms,
          ...mapping.transforms
        };
      }
    
      // 合并 datasource
      if (mapping.datasource) {
        panelDSL.datasource = {
          ...panelDSL.datasource,
          ...mapping.datasource
        };
      }
    });

    console.log('After:', JSON.stringify(panelDSL,null,2));
    console.log('=== Transform End ===');
 // 存入缓存
 metaCache.set(dsl, panelDSL);
    return panelDSL;
  }, [dsl]);
}